import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridPreset } from "@toolkit/Framework/Types/Grid";
import { gridGapStyles } from "@toolkit/Themes/common/mixins";

export const getGridPresetStyles = (preset: GridPreset) => {
    return gridGapStyles(preset.horizontal, preset.vertical);
};

export const getGridPreset = (preset: GridPreset): GridContainerProps => ({
    gap: 0,
    css: getGridPresetStyles(preset),
});
